import { Button, Popconfirm } from "antd";
import { EditOutlined, DeleteOutlined } from "@ant-design/icons";

const UserCard = ({ user, onDelete }) => {
  return (
    <div className="bg-white shadow-md rounded-lg p-4 flex flex-col gap-2 w-96">
      <div>
      <h3 className="text-lg font-semibold text-gray-800">{user.name}</h3>
      <p className="text-sm text-gray-600">Email: {user.email}</p>
      <p className="text-sm text-gray-600">Telefon: {user.phone}</p>
      <p className="text-sm text-gray-600">Rol: {user.role}</p>
      </div>
      <div className="flex justify-end gap-2 mt-2">
        <Button
          type="primary"
          icon={<EditOutlined />}
          size="small"
          className="bg-gray-800 text-white hover:bg-gray-700 flex items-center"
        >
          Düzenle
        </Button>
        <Popconfirm
          title="Bu departmanı silmek istediğinizden emin misiniz?"
          onConfirm={onDelete}
          okText="Evet"
          cancelText="Hayır"
        >
          <Button
          type="primary"
            danger
            size="small"
            className="flex items-center"
            icon={<DeleteOutlined />}
          >
            Sil
          </Button>
        </Popconfirm>
      </div>
    </div>
  );
};

export default UserCard;
